import { RootStateOrAny, useSelector } from 'react-redux';
import './member.scss';
import MemberRegister from '@/components/member/page/memberRegister';
import MemberLogin from '@/components/member/page/memberLogin';
import MemberOtpValidator from '@/components/member/page/memberOtpValidator';
import MemberProfile from '@/components/member/page/memberProfile';
import MemberContainer from '@/components/member/components/memberContainer';
import PropTypes from 'prop-types';

function Member({ storeUuid, storeDisplay }) {
  const memberEnabled = useSelector<RootStateOrAny, any>(
    (state) => state.memberInfoReducer.enabled
  );
  const pageState = useSelector(
    (state: RootStateOrAny) => state.memberReducer.memberPageState
  );

  if (!memberEnabled) return <div />;

  return (
    <MemberContainer isContainerOpen={pageState !== ''}>
      {pageState === 'MemberLogin' && <MemberLogin storeUuid={storeUuid} />}
      {pageState === 'MemberRegister' && (
        <MemberRegister storeUuid={storeUuid} storeDisplay={storeDisplay} />
      )}
      {pageState === 'MemberOtpValidator' && (
        <MemberOtpValidator storeUuid={storeUuid} />
      )}
      {pageState === 'MemberProfile' && <MemberProfile storeUuid={storeUuid} />}
    </MemberContainer>
  );
}

Member.defaultProps = {
  storeUuid: '',
  storeDisplay: '',
};

Member.propTypes = {
  storeUuid: PropTypes.string,
  storeDisplay: PropTypes.string,
};

export default Member;
